import { render, staticRenderFns } from "./EditProgram.vue?vue&type=template&id=cc37b92c&scoped=true"
import script from "./EditProgram.vue?vue&type=script&lang=js"
export * from "./EditProgram.vue?vue&type=script&lang=js"
import style0 from "./EditProgram.vue?vue&type=style&index=0&id=cc37b92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc37b92c",
  null
  
)

export default component.exports